import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Translate } from '../../../Share/components';
import './style.scss';
import { set } from 'lodash';
import AboutAITolk from './AboutAITolk';
import { connect } from 'react-redux';
import { fetchContactPersons, fetchLicenceTypes } from '../../actions/user';
import UserInstruction from './UserInstruction';
import ManageLicense from './ManageLicense';
import ManageLicenseInstruction from './ManageLicenseInstruction';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function AITolk({
  fetchLicenceTypes = () => {},
  onGetContactPersons = () => {},
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    location.state?.tabIndex || 0,
  );

  const handleSelectTab = index => {
    setSelectedTabIndex(index);
    navigate(location.pathname, { state: { tabIndex: index }, replace: true });
  };

  useEffect(() => {
    document.title = `AI-Tolk - TFV Kundportal`;
    fetchLicenceTypes();
    onGetContactPersons();
  }, []);

  useEffect(() => {
    if (
      location.state?.tabIndex !== undefined &&
      location.state.tabIndex !== selectedTabIndex
    ) {
      setSelectedTabIndex(location.state.tabIndex);
    }
  }, [location.state?.tabIndex]);

  return (
    <div className="tv-aiTalk__wrapper">
      <Tabs
        className="tv-aiTalk__tabs-wrapper"
        selectedIndex={selectedTabIndex}
        onSelect={handleSelectTab}
      >
        <div className="tv-aiTalk__tab-list-wrapper">
          <TabList>
            <Tab tabIndex="0">
              <div className="tv-aiTalk__tab-text-main">
                <Translate content="aiTalk.information" />
              </div>
            </Tab>
            <Tab tabIndex="0">
              <div className="tv-aiTalk__tab-text-main">
                <Translate content="aiTalk.manageLicense" />
              </div>
            </Tab>
            <Tab tabIndex="0">
              <div className="tv-aiTalk__tab-text-main">
                <Translate content="aiTalk.userInstruction" />
              </div>
            </Tab>
          </TabList>

          {selectedTabIndex === 1 && <ManageLicenseInstruction />}
        </div>

        <TabPanel className="react-tabs__tab-panel px-0">
          <AboutAITolk />
        </TabPanel>

        <TabPanel className="react-tabs__tab-panel px-0">
          <ManageLicense />
        </TabPanel>

        <TabPanel className="react-tabs__tab-panel px-0">
          <UserInstruction />
        </TabPanel>
      </Tabs>
    </div>
  );
}

AITolk.prototype = {
  fetchLicenceTypes: PropTypes.func,
  onGetContactPersons: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  fetchLicenceTypes: () => {
    dispatch(fetchLicenceTypes());
  },
  onGetContactPersons: () => {
    dispatch(fetchContactPersons());
  },
});

export default connect(null, mapDispatchToProps)(AITolk);
